<template>
  <div class="action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-alert
        style="margin-top: -20px;margin-bottom: 10px;"
        title="提示: 客服统一UID：100001"
        type="warning"
      >
      </el-alert>
      <el-form ref="form" :model="params" :rules="rules" label-width="80px">
        <el-form-item label="用户ID:" prop="uid">
          <el-input v-model.number="params.uid" size="small"></el-input>
        </el-form-item>
        <el-form-item label="内容:" prop="content">
          <el-input
            v-model="params.content"
            type="textarea"
            rows="3"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="sendComment()"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      title: "评论",
      // 提交状态
      flag: false,
      id: "",
      // 回复评论的参数
      params: {
        objID: "",
        cid: "",
        uid: 100001,
        toUserID: "",
        rid: '',
        level: 1,
        content: "",
      },
      // 表单验证规则
      rules: {
        content: [
          { required: true, message: "请输入评论内容", trigger: "blur" },
        ],
        uid: [{ required: true, message: "请输入用户ID", trigger: "blur" }],
      },
    };
  },
  methods: {
    sendComment() {
      const params = Object.assign({}, this.params);
      API.replyComment(params)
        .then((res) => {
          (res.code === 200 &&
            (this.$message.success("评论成功！"),
            this.handleClose(),
            this.$emit("handleList"))) ||
            this.$message.error("操作失败，请重试");
        })
        .catch(() => {
          this.$message.error("操作失败，请重试");
        })
        .finally(() => {
          this.params.content = "";
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        objID: "",
        cid: "",
        rid: '',
        toUserID:'',
        level: 2,
        uid: 100001,
        content: "",
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.params = {
        objID: data.objID,
        cid: data.cid || "",
        //rid: data.rid || '',
        toUserID:data.toUserID || '',
        uid: 100001,
        level: data.level || 2,
        content: "",
      };
    },
  },
};
</script>
